import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseMinNoiseMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/components/fp-logger-noise-min-noise-minimized/fp-logger-noise-min-noise-minimized.component';
import { FpLoggerNoiseMinNoiseComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/components/fp-logger-noise-min-noise/fp-logger-noise-min-noise.component';
import { FpLoggerNoiseMinNoiseActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/services/fp-logger-noise-min-noise/fp-logger-noise-min-noise.actions';
import { FpLoggerNoiseMinNoiseStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/services/fp-logger-noise-min-noise/fp-logger-noise-min-noise.store';
import { Observable } from 'rxjs';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseMinNoiseConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseMinNoiseStore);
  public currentTab = FpLoggerNoiseTabs.MinNoise;

  public component: Type<unknown> = FpLoggerNoiseMinNoiseComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseMinNoiseMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpLoggerNoiseTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseMinNoiseActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseMinNoiseActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
